import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="account-type" on the "New user" form on
// /users — shows the company name field only when "Freelancer" is the
// selected account type, matching NewUserForm.tsx's conditional field. A
// freelancer first gets the choice to invite them as a partner instead.
export default class extends Controller {
  static targets = ["companyNameField", "freelancerChoice"]

  toggle(event) {
    const freelancer = event.target.value === "freelancer"
    this.companyNameFieldTarget.hidden = !freelancer
    if (this.hasFreelancerChoiceTarget) this.freelancerChoiceTarget.hidden = !freelancer
  }
}
